import type { ReactNode } from 'react'

export function StatCard({ title, children }: { title: string; children: ReactNode }) {
	return (
		<section className="card">
			<h2>{title}</h2>
			{children}
		</section>
	)
}

export function Stat({ label, value, tone }: { label: string; value: ReactNode; tone?: 'good' | 'bad' }) {
	return (
		<div className="row" style={{ justifyContent: 'space-between', padding: '0.2rem 0' }}>
			<span className="muted">{label}</span>
			<strong className={tone === 'bad' ? 'error' : tone === 'good' ? 'up' : undefined}>{value}</strong>
		</div>
	)
}
